import { useEffect } from 'react';

const usePersistedDraft = (getValues, onDraftChange) => {
  useEffect(() => {
    if (!getValues || !onDraftChange) {
      return undefined;
    }

    // run as cleanup function
    // similar with on unamount hook
    return () => {
      onDraftChange(getValues());
    };
  }, [getValues, onDraftChange]);
};

export default usePersistedDraft;
